import { render, staticRenderFns } from "./AegPricing.vue?vue&type=template&id=6d70c5f8"
import script from "./AegPricing.vue?vue&type=script&lang=js"
export * from "./AegPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports